<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import {
  issueStructuralDataRequest,
  structuralDataPage
} from '../../../../api/structuralData.js';
import {
  queryCompanyList,
  queryCompanyShuibDict
} from '../../../../api/Draftgeneration.js';

export default {
  name: 'StructuralData',
  data() {
    return {
      tablekey: 0,
      overlength: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      jsonDialogVisible: false,
      jsonDialogTitle: '',
      jsonDialogContent: '',
      issueDialogVisible: false,
      issuing: false,
      issueForm: {
        companyId: '',
        shuibId: '',
        shenbq: '',
        shenbzq: '1'
      },
      issueRules: {
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
        shuibId: [{ required: true, message: '请选择税表', trigger: 'change' }],
        shenbq: [{ required: true, message: '请选择申报期', trigger: 'change' }],
        shenbzq: [{ required: true, message: '请选择申报周期', trigger: 'change' }]
      }
    };
  },
  created() {
    this.getCompanyOptions();
    this.getShuibOptions();
    this.getList();
  },
  computed: {
    canSelectQuarterly() {
      if (!this.issueForm.shenbq) return false;
      return ['03', '06', '09', '12'].includes(this.issueForm.shenbq.slice(4, 6));
    }
  },
  methods: {
    openJsonDialog(value, title) {
      this.jsonDialogTitle = title;
      this.jsonDialogContent = this.formatJson(value);
      this.jsonDialogVisible = true;
    },
    formatJson(value) {
      if (value == null || value === '') return '-';
      if (typeof value === 'object') {
        return JSON.stringify(value, null, 2);
      }
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return String(value);
      }
    },
    getCompanyOptions() {
      queryCompanyList().then(res => {
        if (res.data.code == 1) {
          const options = (res.data.data || []).map(item => ({
            label: item.nsrmc,
            value: item.id
          }));
          this.setSearchOptions('companyId', options);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getShuibOptions() {
      queryCompanyShuibDict().then(res => {
        if (res.data.code == 1) {
          const options = (res.data.data || []).map(item => ({
            label: item.reportName,
            value: item.id
          }));
          this.setSearchOptions('shuibId', options);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    setSearchOptions(prop, options) {
      this.searchlist.forEach(item => {
        if (item.prop === prop) {
          item.selectval = options;
        }
      });
      this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
    },
    formatSearchOption(prop, value) {
      const searchItem = this.searchlist.find(item => item.prop === prop);
      const option = searchItem && (searchItem.selectval || []).find(item => String(item.value) === String(value));
      return option ? option.label : (value == null || value === '' ? '-' : value);
    },
    getSearchOptions(prop) {
      const searchItem = this.searchlist.find(item => item.prop === prop);
      return searchItem ? searchItem.selectval || [] : [];
    },
    openIssueDialog() {
      const now = new Date();
      this.issueForm = {
        companyId: '',
        shuibId: '',
        shenbq: `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`,
        shenbzq: '1'
      };
      this.issueDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.issueForm && this.$refs.issueForm.clearValidate();
      });
    },
    handleIssuePeriodChange() {
      if (this.issueForm.shenbzq === '2' && !this.canSelectQuarterly) {
        this.issueForm.shenbzq = '1';
        this.$message.warning('只有3、6、9、12月可以选择季报');
      }
    },
    submitIssueRequest() {
      this.$refs.issueForm.validate(valid => {
        if (!valid || this.issuing) return;
        if (this.issueForm.shenbzq === '2' && !this.canSelectQuarterly) {
          this.$message.warning('只有3、6、9、12月可以选择季报');
          return;
        }
        this.issuing = true;
        const params = {
          companyId: this.issueForm.companyId,
          shuibId: this.issueForm.shuibId,
          year: this.issueForm.shenbq.slice(0, 4),
          month: this.issueForm.shenbq.slice(4, 6),
          shenbzq: this.issueForm.shenbzq
        };
        issueStructuralDataRequest(params)
          .then(res => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg || '下发成功');
              this.issueDialogVisible = false;
              this.pagination.pageNum = 1;
              this.pagination.paginationkey++;
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .finally(() => {
            this.issuing = false;
          });
      });
    },
    getList() {
      const params = {};
      if (this.searchdata.companyId !== '' && this.searchdata.companyId != null) {
        params.companyId = this.searchdata.companyId;
      }
      if (this.searchdata.shuibId !== '' && this.searchdata.shuibId != null) {
        params.shuibId = this.searchdata.shuibId;
      }
      if (this.searchdata.shenbq) {
        params.shenbq = this.searchdata.shenbq;
      }
      if (this.searchdata.status !== '' && this.searchdata.status != null) {
        params.status = this.searchdata.status;
      }
      const page = {
        current: this.pagination.pageNum,
        size: this.pagination.pageSize
      };
      structuralDataPage(params, page).then(res => {
        if (res.data.code == 1) {
          const pageData = res.data.data || {};
          this.tableData = pageData.records || [];
          this.pagination.total = Number(pageData.total || 0);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getList();
    },
    sizechange(value) {
      this.pagination.pageSize = value;
      this.getList();
    },
    currentChange(value) {
      this.pagination.pageNum = value;
      this.getList();
    },
    geOoverLength(value) {
      this.overlength = value;
    },
    formatStatus(value) {
      return { '0': '失败', '1': '成功', '2': '待执行' }[value] || '-';
    },
    statusClass(value) {
      return {
        '0': 'status-failed',
        '1': 'status-success',
        '2': 'status-pending'
      }[value] || '';
    }
  }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
